module.exports = "/static/media/header-background.3e638194.png";